import axios from "axios";
import { useEffect, useState } from "react";
import { apiURI } from "../ENVs";
import { authErrorRedirect } from "../functions";
import { useNavigate } from "react-router-dom";

export function useApproverHistoryList(sampleRequestID) {
  const [chefHistory, setChefHistory] = useState([]);
  const [executiveChefHistory, setExecutiveChefHistory] = useState([]);
  const [HODHistory, setHODHistory] = useState([]);

  // Navigation function for redirecting
  const history = useNavigate();
  // State for managing errors
  const [errors, setErrors] = useState();
  // State for saving approver list state
  const [isApproverHistoryListLoading, setIsApproverHistoryListLoading] =
    useState(true);

  useEffect(() => {
    setIsApproverHistoryListLoading(true);
    axios
      .get(`${apiURI}/form/getApproverHistory/${sampleRequestID}`)
      .then((response) => {
        setChefHistory(response.data.chefHistory);
        setExecutiveChefHistory(response.data.executiveChefHistory);
        setHODHistory(response.data.HODHistory);
        // setApproverHistoryList(response.data);
        setIsApproverHistoryListLoading(false);
      })
      .catch((error) => {
        console.log("error in axios login call react");
        setErrors({});
        setErrors(error.response?.data);
        authErrorRedirect(error.response?.data, history);
      });
  }, []);
  errors && console.log(errors);

  return {
    approverHistoryList: {
      chefHistory,
      executiveChefHistory,
      HODHistory,
    },
    isApproverHistoryListLoading,
  };
}
